import { Route, Routes, useNavigate } from "react-router";
import Footer from "./footer";
import Sidebar from "./sidebar";
import imgoff from '../images/switchoff.jpg';
import Logout from "./logout";
import Facilities from "./facilities";
import Customers from "./customers";
import Resources from "./resources";
import Plans from "./plans";
import Memberships from "./memberships";
import MeetingRooms from "./meetingrooms";
import Users from "./users";
import PendingInvoices from "./pendinginvoices";
import TaxInvoices from "./taxinvoices";
import SimpleInvoices from "./simpleinvoices";
import Payments from "./pauments";
import RptDues from "./rptdues";
import RptJoinings from "./rptjoinings";
import RptRenewalDue from "./rptrenewaldue";
import RptRenewalExpired from "./rptrenewalexpired";
import Messages from "./messages";
import Ledger from "./ledger";
import AccountHeads from "./accountheads";
import ChangePassword from "./changepassword";
import { useLayoutEffect } from "react";
import Dashboard from "./dashboard";
import OldCustomers from "./oldcustomers";
import VirtualInvoices from "./virtualinvoices";
import VirtualClients from "./virtualclients";
import MeetingInvoices from "./meetinginvoices";
import MeetingClients from "./meetingclients";
import InstantInvoices from "./instantinvoices";
import InstantClients from "./instantclients";
import PaymentLedger from "./paymentledger";
import RPTPaymentDue from './rptPaymentDue';
import Query from "./query";
import SubscriberMessages from "./subscribermessages";
function AdminHome()
{
    let nav=useNavigate();
    useLayoutEffect(()=>
    {
        if(localStorage.getItem("token")=="")
        {
            nav("/");
        }        
    });
    return(
        <>
            {/* Top Navigation (Mobile Only) */}
            <nav className="navbar navbar-light bg-light d-md-none">
                <button
                className="btn btn-primary"
                data-bs-toggle="offcanvas"
                data-bs-target="#mobileSidebar"
                >
                ☰
                </button>
                <span className="navbar-brand">
                    <img src={imgoff} style={{width:'30px'}} />
                </span>
            </nav>

            <div className="d-flex">
                <Sidebar/>
                {/* Main Content */}
                 <div className="flex-grow-1 p-2" style={{ overflowX: "auto" }}>
                    <div className="border rounded-2 p-2 shadow">                    
                        <Routes>
                            <Route path="facilities" element={<Facilities/>} />
                            <Route path="customers" element={<Customers/>} />
                            <Route path="oldcustomers" element={<OldCustomers/>} />
                            <Route path="resources" element={<Resources/>} />
                            <Route path="plans" element={<Plans/>} />
                            <Route path="membership" element={<Memberships/>} />
                            <Route path="meetingrooms" element={<MeetingRooms/>} />
                            <Route path="users" element={<Users/>} />
                            <Route path="pendinginvoices" element={<PendingInvoices/>} />
                            <Route path="taxinvoices" element={<TaxInvoices/>} />
                            <Route path="simpleinvoices" element={<SimpleInvoices/>} />
                            <Route path="payments" element={<Payments/>} />
                            <Route path="rptdues" element={<RptDues/>} />
                            <Route path="rptnewjoins" element={<RptJoinings/>} />
                            <Route path="rptrendue" element={<RptRenewalDue/>} />
                            <Route path="rptrenexpired" element={<RptRenewalExpired/>} />
                            <Route path="messages" element={<Messages/>} />
                            <Route path="ledgers" element={<Ledger/>} />
                            <Route path="accountheads" element={<AccountHeads/>} />
                            <Route path="password" element={<ChangePassword/>} />
                            <Route path="logout" element={<Logout/>} />
                            <Route path="dashboard" element={<Dashboard/>} />
                            <Route path="" element={<Dashboard/>} />
                            <Route path="virtualinvoices" element={<VirtualInvoices/>} />
                            <Route path="virtualclients" element={<VirtualClients/>} />
                            <Route path="meetinginvoices" element={<MeetingInvoices/>} />
                            <Route path="meetingclients" element={<MeetingClients/>} />
                            <Route path="instantinvoices" element={<InstantInvoices/>} />
                            <Route path="instantclients" element={<InstantClients/>} />
                            <Route path="paymentledger" element={<PaymentLedger/>} />
                            <Route path="monthlydues" element={<RPTPaymentDue/>} />                            
                            <Route path="query" element={<Query/>} />                            
                            <Route path="subscribermessages" element={<SubscriberMessages/>} />
                        </Routes>
                    </div>
                </div>
            </div>
        </>
    );
}
export default AdminHome;